// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/locales/" + {"224":"register","671":"forgetPassword","711":"warranty","966":"login","988":"warrantyDetail"}[chunkId] + "." + {"224":"32351ec6","671":"101e936f","711":"f384a5d9","966":"53be0d44","988":"7729b031"}[chunkId] + ".js";
};